<template>
  <v-dialog
    v-model="isVisible"
    max-width="565"
    @click:outside="$emit('onClose')"
    @keydown.esc="$emit('onClose')"
    persistent
  >
    <v-card style="background-color: #1a1a1a" class="ma-0" outlined>
      <v-form ref="modalForm" @submit.prevent="startSubmit">
        <v-row class="mr-6 ml-6 mb-0 pb-0 flex-nowrap">
          <h1 class="pa-0 mt-6">{{ title }}</h1>
          <v-spacer />
          <v-icon @click="$emit('onClose')" class="mt-7 mr-1 flex-shrink-0">
            $iconClose
          </v-icon>
        </v-row>
        <v-row class="mr-6 ml-6 mb-0 pb-0 mt-6" v-if="warning">
          <p class="body1 text-red-darker">{{ warning }}</p>
        </v-row>
        <v-row v-if="inputs.length > 0" class="mr-6 ml-6 mt-6" justify="center">
          <v-col class="ml-0 mr-0 pa-0" max-width="514">
            <div v-for="(input, index) in inputs" :key="index">
              <v-subheader class="mb-1 ml-0 pl-0" style="height: auto"
                >{{ input.label }}
              </v-subheader>
              <v-text-field
                v-if="!input.selectValues"
                max-width="514px"
                class="mb-4"
                rounded
                outlined
                filled
                :value="input.value"
                :hint="input.hint"
                :placeholder="input.placeholder"
                @input="(value) => $store.commit(input.mutation, value)"
                hide-details="auto"
                :rules="input.rules"
                persistent-hint
                :readonly="input.readonly"
              />
              <niko-dropdown
                v-else
                class="mb-1"
                :class="{ 'mb-10': index === inputs.length - 1 && !info }"
                :items="input.selectValues"
                :item-text="input.selectItemText"
                :item-value="input.selectItemValue"
                :value="input.value"
                :rules="input.rules"
                @onSelect="
                  (value) => {
                    input.mutation && $store.commit(input.mutation, value);
                    input.emitOnSelect && $emit(input.emitOnSelect, value);
                  }
                "
              ></niko-dropdown>
            </div>
            <div v-if="info" class="caption text-grey-darker">
              {{ info }}
              <template v-if="extraInfo">
                <br />
                {{ extraInfo }}
              </template>
            </div>
          </v-col>
        </v-row>
        <v-row v-else class="mt-5 mb-5"></v-row>
        <v-row
          v-if="secondaryButtonText || primaryButtonText"
          class="mr-6 ml-6 pb-5 mt-3"
          justify="end"
        >
          <v-card-actions class="ma-0 pa-0">
            <niko-button
              v-if="secondaryButtonText"
              plain
              :text="secondaryButtonText"
              @onClick="$emit('onClose')"
            ></niko-button>
            <niko-button
              v-if="primaryButtonText"
              class="ml-4"
              :text="primaryButtonText"
              type="submit"
              primary
            ></niko-button>
          </v-card-actions>
        </v-row>
        <v-row v-else class="mt-5 mb-5"></v-row>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import NikoButton from "./NikoButton";
import NikoDropdown from "./NikoDropdown";

export default {
  components: { NikoButton, NikoDropdown },
  name: "niko-modal",
  props: {
    title: String,
    warning: String,
    info: String,
    extraInfo: String,
    isVisible: Boolean,
    primaryButtonText: String,
    secondaryButtonText: String,
    inputs: Array,
  },
  methods: {
    startSubmit() {
      if (this.$refs.modalForm.validate()) {
        this.$emit("onSubmit");
      }
    },
  },
};
</script>
<style scoped>
.v-text-field--filled:not(.v-text-field--single-line) input {
  margin-top: 1px;
}
.v-subheader {
  color: white;
}
.v-input__control {
  align-items: center;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 16px;
}
.theme--dark.v-card.v-card--outlined {
  border: thin solid rgba(255, 255, 255, 0.5);
}
</style>
